const PROD_API_HOST = 'https://api.bainocular.seleccionconsulting.com';
const DEV_API_HOST = 'https://api-dev.bainocular.seleccionconsulting.com';

/** Dev API when app runs on localhost or a hostname containing "dev". */
function isDevEnvironment() {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname.toLowerCase();
  return host.includes('dev') || host === 'localhost' || host === '127.0.0.1';
}

//const apiHost = isDevEnvironment() ? DEV_API_HOST : PROD_API_HOST;
export const apiHost = "https://api-dev.bainocular.seleccionconsulting.com";

export const baseURL = `${apiHost}/api`;
export const getThanksgivingConfigURL = `${apiHost}/get/thanksgivingconfig`;
export const saveThanksgivingConfigURL = `${apiHost}/save/thanksgivingconfig`;
export const logApiURL = `${apiHost}/log`;
export const userLogApiURL = `${apiHost}/user-log`
/** Default password assigned to new users — triggers mandatory reset on login */
export const DEFAULT_USER_PASSWORD = 'ConsultantSCC@123';

/** Admin reset password endpoint */
export const adminResetPasswordURL = `${baseURL}/admin/reset-password`;

export const systemMonitoringHistoryURL = `${baseURL}/history`;

/** SLA ticket upload — maintains sla_tickets_data */
export const maintainTicketsURL = `${apiHost}/maintain_tickets`;

/** Classification records endpoint */
export const classificationRecordsURL = `${apiHost}/v1/classification/records`;

/** Classification sentence endpoint – classify a single sentence */
export const classificationSentenceURL = `${apiHost}/v1/classification/sentence`;

/** Problem description endpoint – generates summary from raw request text */
export const vectorizerProblemDescriptionURL = `${apiHost}/get-problem-description`;

/** Similar tickets / KEDB query */
export const vectorizerSimilarTicketsURL = `${apiHost}/v3/lux/similar-tickets/query`;

/** Context search — KEDB image + text query */
export const contextSearchQueryURL = `${apiHost}/context-search/query`;

/** Grouping & RCA — filter dropdowns, shortlist, run, cross-group query */
export const groupingFiltersURL = `${baseURL}/grouping/filters`;
export const groupingShortlistURL = `${baseURL}/grouping/shortlist`;
export const groupingRunURL = `${baseURL}/grouping/run`;
export const groupingQueryURL = `${baseURL}/grouping/query`;
/** Excel export — note: lives at host root, not under /api */
export const groupingExportURL = `${baseURL}/grouping/export`;

/** Legacy power search endpoint */
export const powerSearchURL = `${apiHost}/power-search`;

/** AI Power Search (session-aware) — used by Web Suggested Actions */
export const aiPowerSearchURL = `${apiHost}/ai-power-search`;

/** AI Power Search image upload — used by Web Suggested Actions */
export const aiPowerSearchImageURL = `${apiHost}/chat-image`;

/** Background Job Monitoring – base URL; job list feed at `backgroundJobMonitorFeedURL` */
export const backgroundJobMonitorBaseURL = apiHost;

export const backgroundJobMonitorFeedURL = `${apiHost}/background-jobs`;

/** Failed IDOC Monitoring feed */
export const failedIdocMonitorFeedURL = `${apiHost}/failed-idocs`;

/** Thanks Giving Monitoring — Excel report by interval (POST body: { interval: "2" | "4" }) */
export const fetchThanksgivingMonitoringReportURL = `${apiHost}/fetch_thankgiving_monitoring_report`;
/** Legacy GET by cadence — prefer fetchThanksgivingMonitoringReportURL */
export const thanksgivingMonitoringReportURL = `${apiHost}/get_thankgiving-monitoring_report`;

/** Retrigger failed IDOC (single) */
export const retriggerIdocsURL = `${apiHost}/retrigger-idocs`;

/** Retrigger multiple failed IDOCs in bulk */
export const retriggerBulkIdocsURL = `${apiHost}/retrigger-bulk-idocs`;

/** Job & Application configuration CRUD (same host as `baseURL`) */
export const configurationJobsURL = `${baseURL}/configuration/jobs`;
export const configurationApplicationsURL = `${baseURL}/configuration/applications`;
export const configurationFailedIdocsURL = `${baseURL}/configuration/failed-idocs`;
export const configurationGlobalIntervalsURL = `${baseURL}/configuration/global-intervals`;
export const configurationThanksgivingMonitoringURL = `${baseURL}/configuration/thanksgiving-monitoring`;
export const sendEmailNotificationURL = `${baseURL}/configuration/send-email`;

/** System configuration (database credentials, URLs, etc.) */
export const configurationsURL = `${baseURL}/configurations`;
export const configurationsSaveURL = `${baseURL}/configurations/save`;

/** Thanksgiving configuration — interval cadence & RICEF ID filters */
export const addRicefFiltersURL = `${baseURL}/add-ricefid-filters`;
export const addDistributionFiltersURL = `${baseURL}/add-distribution-filters`;
/** Option 2 (4-hour cadence) separate lists */
export const addRicefFilters2URL = `${baseURL}/add-ricefid-filters-2`;
export const addDistributionFilters2URL = `${baseURL}/add-distribution-filters-2`;
export const THANKSGIVING_INTERVAL_FIELD_ID = "6ca24dbd-2edb-41f5-809f-549aff15eafc";
export const THANKSGIVING_RICEFIDS_FIELD_ID = "74443983-fb35-4d70-b317-0263b4accdb4";
export const THANKSGIVING_RICEFIDS2_FIELD_ID = null; // assigned by backend when ready

/** User activity logs — supports from_date / to_date query params (YYYY-MM-DD) */
export const userActivityURL = `${apiHost}/download_user_activity`;

/** Get logs — POST { from_date, to_date } → JSON array of log entries */
export const getLogsURL = `${apiHost}/get-logs`;

/** Luxottica Helpdesk — incident detail (Manage Queue ticket link) */
export const luxotticaHelpdeskLoginUrl =
  'https://helpdesk.luxottica.com/HDAPortal/Authentication/Login?ReturnUrl=%2fHDAPortal%2f';

export function getLuxotticaTicketUrl(requestId) {
  const id = String(requestId ?? '').trim();
  if (!id) return null;
  return `${luxotticaHelpdeskLoginUrl}#/WSCView/Detail/${id}$entity=Incident`;
}
